(() => {
  if (customElements.get('guya-bundle')) return;
  class GuyaBundle extends HTMLElement {
    connectedCallback() {
      if (this.ready) { this.mobile.addEventListener('change', this.layoutChanged); return; }
      this.ready = true;
      this.items = new Map();
      this.copy = JSON.parse(this.querySelector('[data-gl-copy]').textContent);
      this.discountCopy = JSON.parse(this.querySelector('[data-gl-discount-copy]').textContent);
      this.tiers = JSON.parse(this.querySelector('[data-gl-discount-tiers]').textContent);
      this.format = new Intl.NumberFormat(this.dataset.locale, {style:'currency', currency:this.dataset.currency});
      this.list = this.querySelector('[data-gl-selected]');
      this.submit = this.querySelector('[data-gl-submit]');
      this.status = this.querySelector('[data-gl-status]');
      this.mobile = window.matchMedia('(max-width:800px)');
      this.summary = this.querySelector('[data-gl-summary-details]');
      this.summary.open = !this.mobile.matches;
      this.layoutChanged = () => { this.summary.open = !this.mobile.matches; };
      this.mobile.addEventListener('change', this.layoutChanged);
      this.querySelectorAll('[data-gl-product]').forEach(card => {
        const option = card.querySelector('select').selectedOptions[0];
        if (option) card.querySelector('[data-gl-price]').textContent = this.format.format(Number(option.dataset.price)/100);
      });
      this.addEventListener('change', e => {
        if (!e.target.matches('[data-gl-variant]')) return;
        const card = e.target.closest('[data-gl-product]');
        const option = e.target.selectedOptions[0];
        card.querySelector('[data-gl-price]').textContent = this.format.format(Number(option.dataset.price)/100);
        card.querySelector('[data-gl-add]').disabled = option.dataset.available !== 'true';
      });
      this.addEventListener('click', e => {
        const add = e.target.closest('[data-gl-add]');
        if (add && !add.disabled && !this.busy) {
          const card = add.closest('[data-gl-product]');
          const option = card.querySelector('select').selectedOptions[0];
          if (option.dataset.available !== 'true') return;
          const old = this.items.get(option.value);
          this.items.set(option.value, {id:option.value, title:card.dataset.title, variant:option.textContent.trim()==='Default Title'?'':option.textContent, price:Number(option.dataset.price), quantity:(old?.quantity || 0)+1});
          this.update();
        }
        const action = e.target.closest('[data-gl-action]');
        if (action && !this.busy) {
          const item = this.items.get(action.dataset.id);
          if (!item) return;
          const focusId = action.dataset.id;
          const focusAction = action.dataset.glAction;
          if (focusAction === 'remove') this.items.delete(item.id);
          else { item.quantity += focusAction === 'plus' ? 1 : -1; if (item.quantity < 1) this.items.delete(item.id); }
          this.update();
          const next = [...this.list.querySelectorAll('button')].find(b=>b.dataset.id===focusId&&b.dataset.glAction===focusAction) || this.list.querySelector('button');
          (next || this.querySelector('[data-gl-add]:not(:disabled)'))?.focus();
        }
        if (e.target.closest('[data-gl-submit]')) this.commit();
      });
      this.update();
    }
    disconnectedCallback() {
      this.mobile?.removeEventListener('change', this.layoutChanged);
    }
    node(tag, text, className) {
      const node = document.createElement(tag);
      if (text !== undefined) node.textContent = text;
      if (className) node.className = className;
      return node;
    }
    action(item, name, text, label) {
      const b = this.node('button', text);
      b.type = 'button'; b.dataset.glAction = name; b.dataset.id = item.id;
      b.setAttribute('aria-label', label+' · '+item.title+' · '+item.variant);
      return b;
    }
    update() {
      const fragment = document.createDocumentFragment();
      let total = 0, count = 0;
      for (const item of this.items.values()) {
        total += item.price * item.quantity; count += item.quantity;
        const li = this.node('li');
        li.append(this.node('strong', item.title),this.node('small',(item.variant?item.variant+' · ':'')+this.format.format(item.price/100)));
        const controls = this.node('div',undefined,'gl-selected-controls');
        const qty = this.node('div',undefined,'gl-qty');
        qty.append(this.action(item,'minus','−',this.copy.quantity+' −'),this.node('output',String(item.quantity)),this.action(item,'plus','+',this.copy.quantity+' +'));
        const remove = this.action(item,'remove',this.copy.remove,this.copy.remove); remove.className='gl-remove';
        controls.append(qty,remove);li.append(controls);fragment.append(li);
      }
      this.list.replaceChildren(fragment);
      this.querySelector('[data-gl-empty]').hidden = count > 0;
      const tier = this.tiers.filter(t => count >= t.quantity).at(-1);
      const rate = tier?.percent || 0;
      // Estimate per unit in integer minor units; Shopify confirms combinations at checkout.
      const saving = [...this.items.values()].reduce((sum, item) => sum + Math.floor(item.price * rate / 100) * item.quantity, 0);
      const next = this.tiers.find(t => count < t.quantity);
      const nextCopy = next?.quantity-count === 1 ? this.discountCopy.nextOne : this.discountCopy.next;
      const message = next ? nextCopy.replace('[count]', String(next.quantity-count)).replace('[percent]',String(next.percent)) : this.discountCopy.max;
      const active = this.discountCopy.active.replace('[percent]',String(rate));
      this.querySelector('[data-gl-count]').textContent = count ? count+' '+(count===1?this.discountCopy.countOne:this.copy.count)+' · '+rate+' %' : '';
      this.querySelector('[data-gl-next]').textContent = message;
      this.querySelector('[data-gl-rate]').textContent = active;
      this.querySelector('[data-gl-summary-progress]').textContent = message;
      const meter = this.querySelector('[data-gl-meter]');
      meter.value = Math.min(count, Number(meter.max));
      meter.setAttribute('aria-valuetext', count+' '+this.copy.count+'. '+active+'. '+message);
      this.querySelectorAll('[data-gl-milestone]').forEach(el=>{el.dataset.reached=String(count>=Number(el.dataset.glMilestone));});
      this.querySelector('[data-gl-subtotal]').textContent = this.format.format(total/100);
      this.querySelector('[data-gl-saving]').textContent = (saving?'−':'')+this.format.format(saving/100);
      this.querySelector('[data-gl-discount-label]').textContent = this.discountCopy.discount+' ('+rate+' %)';
      this.querySelector('[data-gl-total]').textContent = this.format.format((total-saving)/100);
      this.querySelector('[data-gl-compact-total]').textContent = this.format.format((total-saving)/100);
      this.submit.disabled = count === 0 || this.busy || this.uncertain;
    }
    async commit() {
      if (this.busy || this.uncertain || this.items.size === 0) return;
      this.busy = true;
      this.submit.disabled = true;
      this.submit.textContent = this.copy.adding;
      this.querySelector('.gl-summary').setAttribute('aria-busy','true');
      this.querySelectorAll('[data-gl-add], [data-gl-action], [data-gl-variant]').forEach(b=>{b.dataset.glWasDisabled=String(b.disabled);b.disabled=true;});
      const controller = new AbortController();
      const timer = setTimeout(()=>controller.abort(),20000);
      try {
        const items = [...this.items.values()].map(i=>({id:Number(i.id),quantity:i.quantity,properties:{bundle:'true'}}));
        const response = await fetch(this.dataset.cartAdd,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items}),signal:controller.signal});
        const payload = await response.json();
        if (!response.ok || !Array.isArray(payload.items) || payload.items.length !== items.length) {
          this.uncertain = true;
          this.status.textContent = response.ok ? this.copy.error : this.copy.rejected;
          this.querySelector('[data-gl-cart-link]').hidden = false;
          return;
        }
        this.items.clear();
        this.status.textContent = this.copy.added;
        this.querySelector('[data-gl-cart-link]').hidden = false;
        window.location.assign(window.GuyaMoments ? window.GuyaMoments.navigationUrl(this.dataset.cart) : this.dataset.cart);
      } catch {
        this.uncertain = true;
        this.status.textContent = this.copy.error;
        this.querySelector('[data-gl-cart-link]').hidden = false;
      } finally {
        clearTimeout(timer);
        this.busy = false;
        this.submit.textContent = this.copy.submit;
        this.querySelector('.gl-summary').setAttribute('aria-busy','false');
        this.querySelectorAll('[data-gl-was-disabled]').forEach(b=>{b.disabled=b.dataset.glWasDisabled==='true';delete b.dataset.glWasDisabled;});
        this.update();
      }
    }
  }
  customElements.define('guya-bundle',GuyaBundle);
})();

